module.exports = __webpack_public_path__ + "img/icon-zoom-in.dd5153f0.svg";